let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page056_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page056_game0/audio/false.mp3',
    // positive: 'games/page056_game0/audio/click.mp3',
    // click: 'games/page056_game0/audio/click.mp3',
    icon: {
      on: 'games/page056_game0/img/audioOn.png',
      off: 'games/page056_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 107,
    height: 104,
  },
  layoutItems: [
    // 1
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 2
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 3
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 4
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 5
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 6
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 7
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 8
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 9
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    // 10
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
  ],
  layoutCorrectItems: [
    // 1
    {
      pos: {
        x: 54 + 150 * 0,
        y: 163 + 0 * 0,
      },
    },
    {
      pos: {
        x: 54 + 150 * 1,
        y: 163 + 0 * 0,
      },
    },
    {
      pos: {
        x: 54 + 150 * 2,
        y: 163 + 0 * 0,
      },
    },
    // 2
    {
      pos: {
        x: 54 + 0 * 1,
        y: 163 + 108 * 1,
      },
    },
    {
      pos: {
        x: 54 + 150 * 1,
        y: 163 + 108 * 1,
      },
    },
    {
      pos: {
        x: 54 + 150 * 2,
        y: 163 + 108 * 1,
      },
    },
    // 3
    {
      pos: {
        x: 54 + 0 * 1,
        y: 163 + 108 * 2,
      },
    },
    {
      pos: {
        x: 54 + 150 * 1,
        y: 163 + 108 * 2,
      },
    },
    {
      pos: {
        x: 54 + 150 * 2,
        y: 163 + 108 * 2,
      },
    },
    // 4
    {
      pos: {
        x: 54 + 0 * 1,
        y: 163 + 108 * 3,
      },
    },
    {
      pos: {
        x: 54 + 150 * 1,
        y: 163 + 108 * 3,
      },
    },
    {
      pos: {
        x: 54 + 150 * 2,
        y: 163 + 108 * 3,
      },
    },
    // 5
    {
      pos: {
        x: 54 + 0 * 1,
        y: 163 + 108 * 4,
      },
    },
    {
      pos: {
        x: 54 + 150 * 1,
        y: 163 + 108 * 4,
      },
    },
    {
      pos: {
        x: 54 + 150 * 2,
        y: 163 + 108 * 4,
      },
    },
    // 6
    {
      pos: {
        x: 1469 + 150 * 0,
        y: 163 + 0 * 0,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 1,
        y: 163 + 0 * 0,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 2,
        y: 163 + 0 * 0,
      },
    },
    // 7
    {
      pos: {
        x: 1469 + 150 * 0,
        y: 163 + 108 * 1,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 1,
        y: 163 + 108 * 1,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 2,
        y: 163 + 108 * 1,
      },
    },
    // 8
    {
      pos: {
        x: 1469 + 150 * 0,
        y: 163 + 108 * 2,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 1,
        y: 163 + 108 * 2,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 2,
        y: 163 + 108 * 2,
      },
    },
    // 9
    {
      pos: {
        x: 1469 + 150 * 0,
        y: 163 + 108 * 3,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 1,
        y: 163 + 108 * 3,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 2,
        y: 163 + 108 * 3,
      },
    },
    // 10
    {
      pos: {
        x: 1469 + 150 * 0,
        y: 163 + 108 * 4,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 1,
        y: 163 + 108 * 4,
      },
    },
    {
      pos: {
        x: 1469 + 150 * 2,
        y: 163 + 108 * 4,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    //////////
    // 1
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/5_rabbit.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/01.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/01ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/03.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/03wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/7_mole.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/02.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/02ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 2
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/12_purple.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/06.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/06ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/14_orange.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/05.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/05ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/04.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/04wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 3
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/18_angry.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/08.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/08ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/07.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/07wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/17_calm.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/09.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/09ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 4
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/24_sister.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/12.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/12ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/27_grandma.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/10.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/10ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/11.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/11wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 5
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/35_three.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/14.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/14ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/13.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/13wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/32_robot.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/15.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/15ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 6
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/36_sing.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/16.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/16ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/41_paint.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/17.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/17ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/18.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/18wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 7
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/46_lemon.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/21.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/21ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/19.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/19wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/49_tomato.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/20.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/20ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 8
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/51_cat.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/24.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/24ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/56_canary.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/22.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/22ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/23.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/23wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 9
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/63_pat.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/27.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/27ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/25.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/25wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/59_head.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/26.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/26ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //////////
    // 10
    //////////
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/66_dress.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/30.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/30ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page056_game0/audio/68_jacket.mp3',
          correct: {
            image: {
              src: 'games/page056_game0/img/28.webp',
            },
            width: 107,
            height: 104,
            correctItems: {
              images: [
                {
                  src: 'games/page056_game0/img/28ok.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page056_game0/img/29.webp',
            },
            width: 107,
            height: 104,
            incorrectItems: {
              images: [
                {
                  src: 'games/page056_game0/img/29wr.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 107,
                  height: 104,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
};

export default elements;
